    <template>
    <div>
        <van-popup safe-area-inset-bottom position="bottom" round :style="{ height:height  }" v-model="visible" :close-on-click-overlay="false">
            <div>
                <van-picker :title="title" show-toolbar :confirm-button-text="$t('table.confirm')" :cancel-button-text="$t('table.cancel')" @cancel="cancel" @confirm="confirm" :columns="columns" @change="onChange" />
            </div>
        </van-popup>
    </div>
</template>
    <script>
export default {
    props: {
        visible:{
            type: Boolean,
            default: false,
        },
        height: {
            type: String,
            default: "30%",
        },
        title: {
            type: String,
            default: "",
        },
        columns:{
            type: Array,
            default: () => {
                return [];
            },  
        }
    },
    data() {
        return {
            obj:{}
        };
    },
    created() {},
    methods: {
        onChange(picker, value, index){
            this.obj = {
                picker, value, index
            }
        },
        cancel(){
            this.$emit('update:visible', false)
        },
        confirm(){
            this.$emit('update:visible', false)
            this.$emit('change',this.obj.picker, this.obj.value, this.obj.index)
        }
    },
};
</script>
    <style lang='scss' scoped>
    /deep/{
        .van-picker__cancel{
            color: #0E1822;
        }
        .van-picker__confirm{
            color: #28B86A;
        }
        .van-picker-column__item--selected{
            color: #28B86A;
            background: #F6F9FA;
            border-color:#F6F9FA
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/popup.vue